import type { MembershipsPromotion, Promotion } from '../Promotions.types'

export const isMembershipsPromotion = (promotion: Promotion): promotion is MembershipsPromotion =>
  promotion.type === 'MEMBERSHIPS_SINGLE' || promotion.type === 'MEMBERSHIPS_MULTI'
